import styled from 'styled-components';

const FixedMap = styled.div`
  position: fixed;
  width: 35%;
  top: 60px;
  z-index: 9;
  margin-left:20px;
`;

export default FixedMap;